/// <summary>
/// dashboard visual for a simple signal 
/// Author: AFU<br />
/// Date: 13.8.2026<br />
/// Copyright ©: EUDT GmbH 2026 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 -  13.8.2026                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.DashboardSankey", jQuery.common.vcBaseV4, {


    _create: function () {
        this._createVisual(417);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {
            // Locate the root container element by its CSS class.
            me._setRoot(".vc-dashboard-item-data");
            me.myRoot.css("height", "100%");
           
            // Construct the full DOM tree (menu bar, list panel, detail panel).
            me._buildHtml();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
   
    _initEvents: function () {
        var me = this;
        try {
            // Fetch signals first, then initialize the dashboard with the loaded data.
            me._fetch();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _buildHtml: function () {
        var me = this;
        try {
            me.myHtml = {};
            me.myHtml.wrapper = me._setObj("", "dashboard-sankey").css({ "width": "100%", "height": "100%", "overflow": "hidden", "display": "flex", "flexDirection": "row", "alignItems": "center" });
            me.myHtml.chart = $("<div>").addClass("dashboard-sankey-chart").css({ "width": "100%", "height": "100%", "minWidth": "0" });
            me.myHtml.wrapper.append(me.myHtml.chart);
            me.myRoot.html(me.myHtml.wrapper);

            // When tooltip.useHTML is enabled, Highcharts renders the tooltip as a
            // plain "div.highcharts-tooltip" (no SVG box/fill-opacity involved), so
            // we can give it a fully opaque background via a scoped CSS rule here.
            if (!$("#dashboard-sankey-tooltip-style").length) {
                $("<style>")
                    .attr("id", "dashboard-sankey-tooltip-style")
                    .text(".dashboard-sankey-chart .highcharts-tooltip {"
                        + "padding:0;"
                        + "}"
                        + ".dashboard-sankey-chart .highcharts-tooltip > span {"
                        + "background-color:#FFFFFF;border-radius:3px;padding:8px;display:inline-block;margin:0;"
                        + "}")
                    .appendTo(document.head);
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },


    _fetch: function () {
        var me = this;
        try {
            // AJAX call to the server-side getData method.
            // TypeId 1 corresponds to the "fetch entries" case in the C# switch statement.
            me.getData({ TypeId: 1, SumValues: true, IsSankey: true }, function (result) {
                if (result === null) { me.showMessage(window._RESOURCES.JS_Com.ERR_wrongSettings_lbl, false); return false; }
                me._loadChart(result);
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _loadChart: function (result) {
        var me = this;
        try {

            // The first entry is always the single parent/root node, all following
            // entries are its direct child nodes (no deeper hierarchy for now).
            var entries = [];
            $.each(result.Entries, function (i, s) {
             
                entries.push({
                    name: s.Name + " [" + s.Unit + "]",
                    unit: s.Unit,
                    value: (s.Status > -1 ? s.Value : 0)
                });
            });
           
            if (entries.length < 2) {
                me.myRoot.html($("<div>").addClass("error").html(window._RESOURCES.JS_Com.ERR_wrongSettings_lbl));
                return false;
            }

            var parent = entries[0];
            var children = entries.slice(1);

            var unitByName = {};
            $.each(children, function (i, c) { unitByName[c.name] = c.unit; });

            var valueByName = {};
            $.each(children, function (i, c) { valueByName[c.name] = c.value; });

            var totalValue = 0;
            $.each(children, function (i, c) { totalValue += c.value; });

            // Links with a weight of 0 (or very close to it) are not rendered at all by the
            // sankey series, and if several consecutive nodes have no weight their labels end
            // up stacked on top of each other. To always keep a visible (thin) line and properly
            // spaced out labels, we enforce a minimum weight for the rendered link, while the
            // real value/percentage (used in labels and tooltips) is still taken from valueByName.
            var minWeight = totalValue ? totalValue * 0.05 : 0.01;

            var sankeyData = [];
            $.each(children, function (i, c) {
                sankeyData.push([parent.name, c.name, Math.max(c.value, minWeight)]);
            });

            var seriesList = [{
                type: 'sankey',
                name: '',
                keys: ['from', 'to', 'weight'],
                data: sankeyData,
                nodePadding: 20,
                nodes: [{ id: parent.name, dataLabels: { align: 'left', x: 17 } }]
                    .concat($.map(children, function (c) { return { id: c.name, dataLabels: { align: 'right', x: -17 } }; })),
                dataLabels: {
                    enabled: true,
                    useHTML: true,
                    crop: false,
                    overflow: "allow",
                    nodeFormatter: function () {
                        var name = this.point.name;
                        var value = valueByName[name];

                        if (typeof value === "undefined") {
                            return name;
                        }

                        var percent = totalValue ? (value / totalValue * 100) : 0;
                        return name + ': ' + Highcharts.numberFormat(percent, 2, ',', '.') + '%';
                    },
                    style: { color: "#000000", fontWeight: "normal", textOutline: "none" }
                },
                tooltip: {
                    headerFormat: '',
                    useHTML: true,
                    backgroundColor: "transparent",
                    borderWidth: 0,
                    shadow: false,
                    pointFormatter: function () {
                        var unit = unitByName[this.toNode.name] || '';
                        var value = valueByName[this.toNode.name];
                        var percent = totalValue && typeof value !== "undefined" ? (value / totalValue * 100) : 0;
                        return this.toNode.name + '<br/><b>' + Highcharts.numberFormat(value, 2, ',', '.') + (unit ? ' ' + unit : '')
                            + ' (' + Highcharts.numberFormat(percent, 2, ',', '.') + '%)</b>';
                    },
                    nodeFormatter: function () {
                        var isParent = (this.name === parent.name);

                        if (isParent) {
                            var parentUnit = unitByName[parent.name] || parent.unit || '';
                            return this.name + '<br/><b>' + Highcharts.numberFormat(totalValue, 2, ',', '.') + (parentUnit ? ' ' + parentUnit : '') + '</b>';
                        }

                        var unit = unitByName[this.name] || '';
                        var value = valueByName[this.name];
                        var percent = totalValue && typeof value !== "undefined" ? (value / totalValue * 100) : 0;
                        return this.name + '<br/><b>' + Highcharts.numberFormat(value, 2, ',', '.') + (unit ? ' ' + unit : '')
                            + ' (' + Highcharts.numberFormat(percent, 2, ',', '.') + '%)</b>';
                    }
                }
            }];

            var options = {
                chart: {
                    type: 'sankey',
                    events: {
                        // Hovering a line (link) already highlights it through Highcharts'
                        // built-in sankey hover state, but hovering a node's name label does
                        // not forward the hover to the node/its connected links, since the
                        // HTML data label is a separate DOM element from the node's graphic.
                        // Wire up mouse events on each node's label to replicate that behavior.
                        load: function () {
                            var chart = this;
                            $.each(chart.series[0].nodes, function (i, node) {
                                if (!node.dataLabel || !node.dataLabel.element) { return; }
                                $(node.dataLabel.element).css("cursor", "pointer").on({
                                    mouseover: function (e) {
                                        node.setState('hover');
                                        chart.tooltip.refresh(node);
                                    },
                                    mouseout: function () {
                                        node.setState('');
                                        chart.tooltip.hide();
                                    }
                                });
                            });
                        }
                    }
                },
                title: { text: null },
                tooltip: { useHTML: true, backgroundColor: "transparent", borderWidth: 0, shadow: false },
                series: seriesList
            };

            var ro = new RampOptions();
            var availableHeight = me.element.closest(".dashboard-charts-wrapper").height() || me.element.closest(".grid-stack-item-content").height() || me.myRoot.parent().height() || 300;
            me.myRoot.height(availableHeight);

            // The sankey series always stretches its nodes to fill the full plot area height,
            // so simply centering the container via flexbox has no visible effect (the chart
            // itself still occupies the entire available height). Instead we compute a chart
            // height proportional to the number of node columns/rows so the diagram keeps a
            // reasonable node size, and then let flexbox center that smaller chart box.
            var nodeCount = 1 + children.length;
            var contentHeight = Math.min(availableHeight, Math.max(150, nodeCount * 40));

            me.myHtml.chart.css({ "width": "100%", "flex": "0 1 auto" });
            me.myHtml.chart.height(contentHeight);

            me.myHtml.chart.highcharts($.extend({}, ro.getTheme(), options));

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    _formatNumber: function (number, decimals) {
        var n = parseFloat(number);
        if (isNaN(n)) n = 0;
        var parts = n.toFixed(decimals).split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return decimals > 0 ? parts[0] + "," + parts[1] : parts[0];
    },

    /**
     * Handles error display states for the widget.
     * When an error occurs (bError=true), both the menu bar and content area are hidden,
     * leaving only the framework's error message visible to the user.
     * This ensures a clean UI when the widget cannot function due to missing data or server errors.
     *
     * Called by the framework's built-in error handling mechanism (inherited from vcBaseV4).
     *
     * @param {boolean} bError - true if an error state should be shown, false otherwise.
     * @returns {boolean} true on success, false on error.
     */
    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                // Hide both menu and content to show only the error message.
                me.myHtml.wrapper.hide();
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    }
});